module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmitCheck,
      "failed": _vm.onFailed
    }
  }, [_vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("项目信息" + _vm._s(index + 1) + "\n            ")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "is-link": "",
        "input-align": "right",
        "title": "项目",
        "value": "请选择项目"
      },
      on: {
        "click": function($event) {
          return _vm.openSubjectPicker(_vm.subjectOptionsAll, index)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.subject_name),
        expression: "subject.subject_name"
      }],
      staticClass: "operate-desc-left"
    }, [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), (subject.music_url) ? _c('van-cell', {
      attrs: {
        "title": "规定音乐",
        "value": "点击试听",
        "is-link": ""
      },
      on: {
        "click": function($event) {
          _vm.playMusicUrl = subject.music_url;
          subject.music_url_played = true;
          _vm.showMusic = true
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('van-popup', {
      style: ({
        width: '80%',
        paddingTop: '50px'
      }),
      on: {
        "click-overlay": _vm.onSubjectClose
      },
      model: {
        value: (_vm.showSubjectPicker),
        callback: function($$v) {
          _vm.showSubjectPicker = $$v
        },
        expression: "showSubjectPicker"
      }
    }, [_c('van-cell-group', [_vm._l((_vm.subjectOptions), function(item, index) {
      return (_vm.subjectOptions.length > 0) ? _c('van-cell', {
        key: index,
        attrs: {
          "is-link": ""
        },
        on: {
          "click": function($event) {
            return _vm.onSubjectSelect(item)
          }
        }
      }, [_vm._v(_vm._s(item.name))]) : _vm._e()
    }), _vm._v(" "), (_vm.subjectOptions.length == 0) ? _c('van-cell', [_vm._v("请先绑定俱乐部")]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "native-type": "button",
        "size": "normal",
        "round": "",
        "icon": "close"
      },
      on: {
        "click": function($event) {
          return _vm.subjectRemove(subject, index)
        }
      }
    }, [_vm._v("删除项目" + _vm._s(index + 1))])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "0.4rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": "",
      "icon": "plus"
    },
    on: {
      "click": _vm.subjectAdd
    }
  }, [_vm._v("新增项目")]), _vm._v(" "), (false) ? _c('van-button', {
    staticStyle: {
      "width": "3.5rem",
      "margin-top": "0.4rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": "",
      "icon": "share"
    },
    on: {
      "click": function($event) {
        _vm.show_share_panel = true
      }
    }
  }, [_vm._v("分享给家长填写")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep1',
        query: {
          id: this.$route.query.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep1',query:{id:this.$route.query.id}}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "native-type": "button"
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 2), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": function($event) {
        _vm.showWxShare = false
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])]), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "closeable": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showMusic),
      callback: function($$v) {
        _vm.showMusic = $$v
      },
      expression: "showMusic"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.playMusicUrl && _vm.showMusic) ? _c('audio', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "autoplay": "",
      "src": _vm.playMusicUrl,
      "controls": "controls"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "max-height": "80%",
      "overflow-y": "scroll"
    },
    attrs: {
      "title": "项目错误信息"
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_c('van-cell-group', _vm._l((_vm.errorMsg), function(item) {
    return _c('van-cell', {
      attrs: {
        "title": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "请在复制网址到电脑端操作",
      "confirm-button-text": "关闭"
    },
    model: {
      value: (_vm.musicUrlShow),
      callback: function($$v) {
        _vm.musicUrlShow = $$v
      },
      expression: "musicUrlShow"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0",
      "line-height": "30px"
    }
  }, [_c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.row.music_edit_url),
      expression: "row.music_edit_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }]
  }, [_vm._v("\n                    " + _vm._s(_vm.row.music_edit_url) + "  "), _c('br'), _vm._v(" "), _c('span', [_vm._v("复制")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友(朋友圈)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e305f6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep2Dianxin.vue
// module id = 2208
// module chunks = 0